import FileIcon from '../assets/icon-file.svg?react';

interface DragDropOverlayProps {
  isDragging: boolean;
}

const DragDropOverlay = ({ isDragging }: DragDropOverlayProps) => {
  if (!isDragging) return null;

  return (
    <div className="drag-drop-area">
      <div className="drop-area d-flex flex-column align-items-center justify-content-center">
        <div className="drag-icon relative">
          <FileIcon />
        </div>

        <div className="d-flex flex-column align-items-center justify-content-center">
          <h2 className="drag-title font-aleo">Drag Files Here To Chat</h2>
          <span className="p2 font-aleo mt-2">
            '*.txt, *.pdf,*.doc, *.docx, *.pptx, *.csv, *.xls, *.xlsx, *.png, *.jpeg, *.jpg'
          </span>
        </div>
      </div>
    </div>
  );
};

export default DragDropOverlay;
